import { useBreakpoint } from '@/features/breakpoint/contexts';
import { useAccountInfo } from './query/account';
import { useGetSiteConfigs } from './query/use-site-configs';
import { SetShowPromotionStreamer } from '@/features/promotion';
import { useSelectedLayoutSegments } from 'next/navigation';
import { Breakpoint } from '@/features/breakpoint';
import { useAsideBetslip } from '@/features/betslip/hook/use-aside-betslip';

// 特定元件根據aise bar寬度至中於中間元件, 若特殊元件在沒有aside bar時渲染需要將其往右推
export const usePushAside = () => {
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const { breakpoint } = useBreakpoint();
	// 若為aside bet slip狀態一定有aside bar
	const { activeAsideBetSlip } = useAsideBetslip();
	const ShowPromotionStreamerSrc = SetShowPromotionStreamer();
	const selectedLayoutSegments = useSelectedLayoutSegments();
	const isPromotionPage = selectedLayoutSegments.includes('promotion');
	const isShowPromotionChatroom = SiteConfigsData?.EnableChatroom && user?.ActStatus == 2 && ShowPromotionStreamerSrc.length > 0 && user.RewardInfo.EnableRewardSystem
	return !isShowPromotionChatroom && breakpoint > Breakpoint.lg && isPromotionPage && !activeAsideBetSlip;
}